import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { populateAvailableCarts } from '../../store/ducks/tables/actions';
import { Cart } from '../../store/ducks/freight/types';

export default function useGetCart() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  async function execute(params: {
    freightId?: string;
    cartId: string;
  }): Promise<Cart | undefined> {
    try {
      setLoading(true);
      const response = await api.get(`v1/backoffice/carts/${params.cartId}`, {
        params: {
          freightId: params.freightId,
        },
      });

      if (response.status === 200) {
        dispatch(populateAvailableCarts(response.data));
        return response.data;
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.general.error.operationFailed);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
